var map = {
	"./Co2.svg": 630,
	"./Community.svg": 7345,
	"./Dashboard.svg": 7346,
	"./ESGReports.svg": 7347,
	"./ESG_Frameworks.svg": 7348,
	"./Environment.svg": 7349,
	"./Governance.svg": 7350,
	"./Marketplace.svg": 7351,
	"./Purpose.svg": 7352,
	"./Settings.svg": 7353,
	"./Workplace.svg": 7354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 494;